import { applicationRouteConstants } from '../../shared/_constants/applicationRoutes.constants';
import { LogLevel } from '@azure/msal-browser';

/**
 * MSAL Configuration for Azure AD authentication
 */
export const msalConfig = {
  auth: {
    clientId: '02c8885f-4f2d-4767-aac6-b86fc7cbdf3a',
    authority:
      'https://login.microsoftonline.com/72ca17d4-d1db-496b-8e11-2617ae372f4f',
    redirectUri: `${window.location.origin}${applicationRouteConstants.HUB}`,
    postLogoutRedirectUri: `${window.location.origin}${applicationRouteConstants.DEFAULT}`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error('MSAL Error:', message);
            break;
          case LogLevel.Warning:
            console.warn('MSAL Warning:', message);
            break;
          case LogLevel.Info:
            console.info('MSAL Info:', message);
            break;
          case LogLevel.Verbose:
            console.debug('MSAL Verbose:', message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel?.Warning,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Login request configuration
 */
export const loginRequest = {
  scopes: ['user.read'],
};

/**
 * Token request configuration for API access
 */
export const tokenRequest = {
  scopes: [
    'user.read',
    'api://885ee620-55e8-438c-a1fe-ed82671a2450/allresources.access.asuser',
  ],
};

// Legacy config export for backwards compatibility
const config = {
  appId: msalConfig.auth.clientId,
  redirectUri: msalConfig.auth.redirectUri,
  postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
  authority: msalConfig.auth.authority,
  scopes: tokenRequest.scopes,
};

export default config;
